import MicroModal from 'micromodal';

/**
 * @description モーダルinit
 */

/**
 * @link 参考:https://www.npmjs.com/package/micromodal
 */

export const setModal = () => {
  MicroModal.init({
    awaitCloseAnimation: true,
    awaitOpenAnimation: true,
    disableFocus: true,
    disableScroll: true,
  });
};
